import { Route, Routes } from "react-router-dom";
import NotFound from "../components/NotFound";
import Login from "../views/Login";
import Home from "../views/Home";


const AuthRoutes = () => {
    return (
        
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />


            
            <Route path='*' element={<NotFound />} />
        </Routes>
    );
};

export default AuthRoutes;